module.exports = __webpack_public_path__ + "static/product-widget.02ad9154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-widget.png
// module id = 595
// module chunks = 35783957827783